// extracted by mini-css-extract-plugin
module.exports = {"newarrivals":"NewArrivals_newarrivals__1USBx","arrivalsbox":"NewArrivals_arrivalsbox__2aV24","arrival":"NewArrivals_arrival__qsMjb"};